module.exports = __webpack_public_path__ + "media/honey-icons/icon-ext-link-9272e8c7.svg";